import { Button } from '@apollo/orbit';
import React from 'react';

import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';

interface Props {
  graphId: string;
  buttonText: string;
  onClick: () => void;
  defaultOverrideButtonClassName?: string;
  loading?: boolean;
}

export function DefaultOverrideViolationButton({
  graphId,
  buttonText,
  onClick,
  defaultOverrideButtonClassName,
  loading,
}: Props) {
  const className = defaultOverrideButtonClassName;
  return (
    <PermissionWarning
      graphId={graphId}
      graphPermissions="canWriteCheckConfiguration"
      childRenderer={(hasPermission) => (
        <Button
          variant="secondary"
          className={className}
          isDisabled={!hasPermission}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          isLoading={loading}
          loadingText="Loading"
        >
          {buttonText}
        </Button>
      )}
    />
  );
}
